import { useEffect, useState } from "react";

import { Box, Typography, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";

import { getData } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { LineChart } from "../../../../../components/charts";
import { GraphFooter, NoDataCard } from "../../../../../components/parts";
import { unitGraphFooter, unitComparisonChartLines } from "../../../constants";

const useStyles = makeStyles(() => ({
  consumptionBlock: {
    position: "absolute",
    top: "41%",
    left: "-18px",
    transform: "translateY(-50%)",
  },
  consumption: {
    color: COLORS.darks[0][50],
    fontSize: 10,
    transform: "rotate(-90deg)",
  },
}));

export const PowerConsumptionComparison = ({ unit }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const title = "Avg. Power Consumption Comparison";
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    getData(
      `/praas/v2/buildings/${unit.building.id}/properties/units/${unit.id}/consumption-comparison/`,
      (results) => {
        setChartData(
          results.map((item) => {
            const date = new Date(item.date);
            return {
              x: `${date.getUTCFullYear()}-${date.getMonth() - 1}`,
              _unit: item.unit_consumption,
              avg_building: item.building_consumption,
              avg_portfolio: item.portfolio_consumption,
              avg_industry: item.industry_consumption,
            };
          })
        );
      }
    );

    return () => setChartData([]);
  }, []);

  if (!chartData.length)
    return (
      <NoDataCard
        title={title}
        footerNames={["Unit", "Avg. building", "Avg. portfolio", "Avg. Industry"]}
      />
    );

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Box style={{ marginTop: 56, position: "relative" }}>
          <Box className={classes.consumptionBlock}>
            <Typography className={classes.consumption}>kWh/{user?.unit_system}</Typography>
          </Box>
          {chartData.length ? (
            <LineChart
              chartData={chartData}
              chartLines={unitComparisonChartLines}
              dot={false}
              xAxisPadding={{
                right: 84,
                left: 20,
              }}
              margin={{
                left: 20,
              }}
              hideSum={true}
              toolTipLabel={`Power Consumption (kWh/${user?.unit_system})`}
              unit="nFormatter"
              ticks={[chartData[0].x, chartData[chartData.length - 1].x]}
            />
          ) : null}
          <GraphFooter items={unitGraphFooter} />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
